import appSaga from './app';

export default appSaga;
